import { useState } from 'react';

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: '少妇肌肤和年轻女性肌肤有什么不同？',
    answer: '少妇肌肤（通常指25-40岁女性）面临胶原蛋白加速流失、锁水能力下降、色素沉着增多等独特挑战。与20岁出头的年轻肌肤相比，少妇肌肤更需要注重抗衰、深层保湿和屏障修复。同时，孕期和产后的激素波动也会带来额外的肌肤变化。',
  },
  {
    question: '每天护肤需要多长时间？',
    answer: '我们推荐"早晚各15分钟"的高效护肤方案。晨间以清洁、防护、保湿为主，晚间以深洁、修复、滋养为主。关键在于每一步都做到位，而不是步骤越多越好。具体流程可以参考我们网站上的日常护理专栏。',
  },
  {
    question: '产后多久可以开始使用功能性护肤品？',
    answer: '一般建议产后3个月内以温和保湿和修复为主。3个月后可以逐步加入功能性产品，如维C精华（提亮）、胜肽精华（抗衰）。视黄醇类产品建议哺乳期结束后再使用。具体时间还需根据个人恢复情况和是否哺乳来决定，最好咨询你的皮肤科医生。',
  },
  {
    question: '口服胶原蛋白真的有效吗？',
    answer: '近年来的研究表明，水解胶原蛋白肽确实可以通过刺激皮肤成纤维细胞来促进自身胶原蛋白的合成。但效果因人而异，需要选择分子量合适的产品（2000-5000道尔顿），配合维生素C，并坚持至少8周以上才能看到改善。口服胶原蛋白是护肤的"加分项"而非"替代项"。',
  },
  {
    question: '如何判断自己的肤质？',
    answer: '最简单的方法是"裸脸观察法"：晚上洁面后不涂抹任何护肤品，第二天早上观察。全脸出油明显为油性肤质；T区出油、两颊偏干为混合性；全脸紧绷甚至起皮为干性；泛红、刺痛、发热则为敏感性。少妇群体中，混合性和敏感性肤质最为常见。',
  },
  {
    question: '防晒霜需要每天使用吗？冬天和室内也需要吗？',
    answer: '是的，防晒是护肤的基石，无论季节和天气。UVA（导致光老化的紫外线）可以穿透云层和玻璃，即使在室内靠窗的位置也需要防护。冬季雪地的紫外线反射率高达80%，反而更需要防晒。建议每天使用SPF30以上、PA+++以上的防晒产品。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">关于少妇护肤的常见疑问，这里有专业解答</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}